/**
 * Mega dropdown — Add to Cart AJAX
 * Intercepte les boutons .nav-atc-btn[data-variant-id] dans le dropdown navigation
 * et ajoute le produit au panier sans rechargement de page.
 */

(function () {
  'use strict';

  // ── Helpers ──────────────────────────────────────────────────────────────

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartNotification() {
    return document.querySelector('cart-notification');
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        // Met à jour tous les compteurs du panier dans le header
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach((el) => {
          el.textContent = cart.item_count;
        });
        // Bubble visible/cachée
        document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
          bubble.classList.toggle('hidden', cart.item_count === 0);
        });
      })
      .catch(() => {});
  }

  function openCart(triggerEl) {
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(triggerEl);
      return;
    }
    // Fallback : forcer un refresh du drawer s'il existe
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('cart:open'));
    }
  }

  // ── Fermer le dropdown après l'action ───────────────────────────────────

  function closeParentDropdown(btn) {
    const details = btn.closest('details.mega-menu--products');
    if (details) details.removeAttribute('open');
  }

  // ── Bouton Add to Cart ───────────────────────────────────────────────────

  function handleAddToCart(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) return res.json().then((d) => Promise.reject(d));
        return res.json();
      })
      .then(() => {
        // Succès
        btn.textContent = '✓ Ajouté';
        btn.classList.add('nav-atc-btn--added');
        refreshCartCount();

        // Réinitialiser le bouton après 2 s puis ouvrir le drawer
        setTimeout(() => {
          btn.textContent = originalText;
          btn.classList.remove('nav-atc-btn--added');
          btn.disabled = false;
          closeParentDropdown(btn);
          openCart(btn);
        }, 1200);
      })
      .catch((err) => {
        const msg = err && err.description ? err.description : 'Erreur';
        btn.textContent = msg.substring(0, 20);
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2500);
      });
  }

  // ── Écoute des clics ─────────────────────────────────────────────────────

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.nav-atc-btn[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    handleAddToCart(btn);
  });

  // ── Fermer le dropdown quand on clique ailleurs ──────────────────────────

  document.addEventListener('click', (e) => {
    if (e.target.closest('.mega-menu--products')) return;
    document.querySelectorAll('details.mega-menu--products[open]').forEach((d) => {
      d.removeAttribute('open');
    });
  });

  // ── Hover ouvert/fermé sur desktop ───────────────────────────────────────

  function initHoverMenus() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const allMenus = document.querySelectorAll('header-menu');

    allMenus.forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;

      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        // Ferme les autres dropdowns ouverts
        allMenus.forEach((other) => {
          if (other !== menu) {
            const otherDetails = other.querySelector('details');
            if (otherDetails && otherDetails.hasAttribute('open')) {
              if (typeof other.close === 'function') {
                other.close();
              } else {
                otherDetails.removeAttribute('open');
              }
            }
          }
        });
        details.setAttribute('open', '');
      });

      // Sur desktop : clic sur le lien → navigation, clic ailleurs sur summary → rien (hover gère l'ouverture)
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          if (e.target.closest('a[href]')) return; // laisser naviguer
          e.preventDefault();
        });
      }

      menu.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          if (typeof menu.close === 'function') {
            menu.close();
          } else {
            details.removeAttribute('open');
          }
        }, 80);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();
